import React from "react";
import {Table, DatePicker, Input, Card, Modal, Button, Select, Form, InputNumber, Upload,
  Drawer, Timeline, Icon, message, Tooltip, Popover, Checkbox} from "antd";
import {Images} from "../../../controller/Images"
import {WorkOrderList, WorkOrderPDFList, WorkOrderUpdate} from "../../../models/workorder";
import {pagination, toList} from "../../../controller/Utils";
import {AddUpdateWorkOrder} from "../../tracks/workorder/popups/AddUpdateWorkOrder";
import {ShowWorkOrder} from "../../tracks/workorder/popups/ShowWorkOrder";
import {ChoiceWorkOrderCreate} from "../../tracks/workorder/popups/ChoiceWorkOrderCreate";
import {ImportQuote} from "../../tracks/workorder/popups/ImportQuote";
import {Config} from "../../../controller/Global";
import {CrmHeaderLinks} from "../CrmHeaderLinks";
import {Task} from "./log_components/Task";
import {TaskStatus} from "./log_components/TaskStatus";
import {AddUpdateTaskForm} from "./popups/AddUpdateTask";

const moment = require('moment');

const { RangePicker } = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;
const WORKORDER = 'workorder';
const MANIFEST = Config.constant.service_type.manifest;
const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;

export class ProjectLog extends React.Component{
  state = {
    visible: false,
    visibleWorkDrawer: false,
    visibleDetails: false,
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    params: {},
    printVisible: false,
    printChoices: {},
    printBtnLoading: false
  }
  showPrintModal = (row_id) => {
    this.setState({
      printVisible: true,
      row_id: row_id
    });
  }

  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  }

  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.field}`,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({loading: true, params});
    params['table'] = true;
    WorkOrderList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'created',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };

  PDFPrintOption = (counter = 0) => {
    const {row_id, printChoices} = this.state;
    const data = toList(printChoices);
    const key = Object.keys(printChoices)[counter]
    if (key === WORKORDER) {
        WorkOrderPDFList({ids: row_id, pdf_type: WORKORDER})
          .then(response => {
            counter += 1;
            if (data.length === counter)
              this.setState({printBtnLoading: false, printVisible: false, printChoices: {}});
             else
               this.PDFPrintOption(counter, data)
          })
      }
      else if (key && key.startsWith(MANIFEST)) {
        WorkOrderPDFList({ids: row_id, manifest: printChoices[key], pdf_type: MANIFEST})
          .then(response => {
            counter += 1;
            if (data.length === counter)
              this.setState({printBtnLoading: false, printVisible: false, printChoices: {}})
            else
              this.PDFPrintOption(counter, data)
          })
      }
  }
  onWorkorderRowPrintClick = () => {
    this.setState({printBtnLoading: true});
    this.PDFPrintOption()
  };

  onMultipleRowDeleteClick = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length)
      this.onRowDeleteClick(selectedRowKeys);
    else
      message.info('Please select any one row for delete');
    this.setState({
      selectedRowKeys: []
    })
  };

  onRowDeleteClick = (keys) => {
    const $this = this;
    confirm({
      title: 'Are you sure move to trash this work order(s)?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      centered: true,
      onOk() {
        keys.forEach(id => {
          WorkOrderUpdate(id, {'is_delete': true})
            .then(response => {
              message.success('Work Order(s) move to trash successfully');
              $this.fetch();
            });
        });
      },
    });
  };
  onRowShowClick = (ids) => {
    this.setShowWorkOrderModel(true);
    this.setState({ showWorkOrderModelData: ids })
  };
  onRowUpdateClick = (moderatedWorkOrder) => {
    this.setState({ moderatedWorkOrder });
    this.setAddUpdateWorkOrderModel(true);
  };
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye" /></a>
        <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil" /></a>
        <a title="Move to Trash" onClick={() => this.onRowDeleteClick([item.id])}><i className="fa fa-trash" /></a>
        <a title="Print" onClick={() => this.showPrintModal(item.id)} ><i className="icon-printer" /></a>
      </div>
    }, {
      title: 'Created Date',
      dataIndex: 'created',
      sorter: true,
      render: created => moment(created).format('YYYY-MM-DD')
    }, {
      title: 'Work Order Number',
      dataIndex: 'work_order_number',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip placement="top" title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span className="uppercase-letter">{generator.company_name}<br />ID: {generator.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      render: bill_to => <Tooltip placement="top" title={`${bill_to.address} ${bill_to.city} ${bill_to.zip_code}`}><span>{bill_to.company_name}<br /> ID: {bill_to.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    },
    {
      title: <span className="billto-column-tbl">Truck Type</span>,
      dataIndex: 'service',
      key :'truck_type',
      render: service => service.map(service => service.truck_type.map(type => type.type_name).join(', ')).join(' | '),
    },
    {
      title: 'Transporter',
      dataIndex: 'service',
      key: 'transporter',
      render: service =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.transporter.name}</p>)}
          </div>}
          title="All Transporter">
          <a type="primary">{service[0].transporter.name} <i className="fa fa-info-circle" /></a>
        </Popover>,
      sorter: true
    },
    {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service date',
      sorter: true,
      render: (service) =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.service_date}<Tooltip title={item.status}><span className={"status-services " + (item.status)}><i className="fa fa-circle" /></span></Tooltip></p>)}
          </div>} title="All Service Date">
          <a type="primary">{service[0].service_date} <i className="fa fa-info-circle" /></a>
        </Popover>
    }, {
      title: 'Status',
      dataIndex: 'service',
      sorter: false,
      render: (service) => {
        const pending = service.filter(item => item.status !== 'completed').length;
        if (!pending)
          return <Tooltip title="Completed"><span className="completed"><i className="fa fa-circle" /></span></Tooltip>;
        else if (pending !== service.length)
          return <Tooltip title="Partially"><span className="partially"><i className="fa fa-circle" /></span></Tooltip>
        else
          return <Tooltip title="Pending"><span className="pending"><i className="fa fa-circle" /></span></Tooltip>
      }
    }
  ];
  openImportQuoteModel = (selectQuoteVisible) => {
    this.setState({ selectQuoteVisible });
    this.setChoiceWorkOrder(false);
  };
  onMultipleRowShowClick = () => {
    const {selectedRowKeys} = this.state;
    if (selectedRowKeys.length)
      this.onRowShowClick(selectedRowKeys);
    else
      message.info('Please select any one row for show');
  };
  selectedChoicesPrint = (e) => {
    let {printChoices} = this.state;
    if (!e.target.checked)
      delete printChoices[e.target.name];
    else {
      printChoices[e.target.name] = e.target.value;
      this.setState({printChoices});
    }
  }
  openAddNewWorkOrder = () => {
    this.setState({ moderatedWorkOrder: false });
    this.setAddUpdateWorkOrderModel(true);
    this.setChoiceWorkOrder(false)
  };

  componentDidMount() {
    this.fetch();
  }

  setAddUpdateWorkOrderModel(addUpdateWorkOrderModel) {
    this.setState({ addUpdateWorkOrderModel });
  }

  setShowWorkOrderModel(showWorkOrderModel) {
    this.setState({ showWorkOrderModel });
  }

  setSelectQuoteVisible(selectQuoteVisible) {
    this.setState({ selectQuoteVisible });
  }

  setChoiceWorkOrder(setChoiceWorkOrderModel) {
    this.setState({ setChoiceWorkOrderModel })
  }

  showWorkDrawer = () => {
    this.setState({
      visibleWorkDrawer: true,
    });
  };

  onCloseWork = () => {
    this.setState({
      visibleWorkDrawer: false,
    });
  };
  showDetailsDrawer = (visible) => {
    this.setState({
      visibleDetails: visible,
    });
  };

    showModalCoordinator = (showModal) => {
      this.setState({
        visible: showModal,
      });
    }

    handleOk = (e) => {
      this.setState({visible: false});
    }

    handleCancel = (e) => {
      this.setState({ visible: false });
    }
  render() {
    const {pagination, data, loading, selectedRowKeys, row_id, printBtnLoading,fields} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
        <div id="main-content">
          <div className="container-fluid">
            <div className="block-header">
              <div className="row clearfix crm-bdr">
                <div className="col-sm-4 col-12">
                  <h3 className="main-heading">CRM</h3>
                </div>
                <div className="col-sm-8 col-12">
                  <CrmHeaderLinks/>
                </div>
              </div>
              <div className="row clearfix m-t-15">
                <div className="col-12">
                  <h3 className="main-heading">Job Information</h3>
                </div>
              </div>
              <div className="row clearfix margin-0">
                <div className="col-sm-9 col-xs-120">
                  <div className="row clearfix main-card">
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Client"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <h4>Con Edison</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Project Site"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <h4>XYZ</h4>
                        <p>ID: <a>10002</a></p>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Project Bill TO"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <h4>Orbin Residance TT</h4>
                        <p>ID: <a>10002</a></p>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Project Contact"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <h4>Paul Smith</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Project Manager"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <h4>Julia Anderson</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Job Scope"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <h4>Julia Anderson</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Start Date"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                          <h4>15-01-2019</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Status"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                          <h4>Approved</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Financial Status"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <div className="col-12 padding-0 multiple-enrty">
                          <h4>Approved</h4>
                          <p>ID: <a>12345</a></p>
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Task"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <div className="col-12 padding-0 multiple-enrty">
                          <h4>6/10</h4>
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="P&L Summary"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <div className="col-12 padding-0 multiple-enrty">
                          <h4>ID: <a>12.6%</a></h4>
                          <p>Revenue: <a>$12335.43</a></p>
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card
                        title="Calendar Alert"
                        extra={<a  href="#"><i className="fa fa-info"> </i> </a>}
                        style={{ width: "100%" }}
                        bordered={false}
                      >
                        <div className="col-12 padding-0 multiple-enrty">
                          <p>Margin <a>12.6%</a></p>
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3 col-xs-12 paddingZ-xs">
                  <div className="job-details-bar">
                    <h4>Edit Job Details</h4>
                    <ul>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Alerts <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Financial <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Progress <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Project P&L <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Calendar <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Resources List <i className="fa fa-pencil"> </i></a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Proposal <i className="fa fa-pencil"> </i></a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Tasks <i className="fa fa-pencil"> </i></a></li>
                      <li><a onClick={()=>this.showDetailsDrawer(true)} href="#">Job Files <i className="fa fa-pencil"> </i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row clearfix timeline-card">
                <h4>Job Timeline</h4>
                <ul className="timeline-bar-list">
                  <li><div>Step 1 <span>168 days ago</span></div></li>
                  <li><div>Step 2 <span>168 days ago</span></div></li>
                  <li><div>Step 2 <span>168 days ago</span></div></li>
                  <li><div>Step 3<span>168 days ago</span></div></li>
                  <li><div>Step 4 <span>168 days ago</span></div></li>
                  <li><div>Step 5 <span>168 days ago</span></div></li>
                  <li><div>Step 6 <span>168 days ago</span></div></li>
                  <li><div>Step 7 <span>168 days ago</span></div></li>
                </ul>
              </div>
             <div className="row clearfix edit-header">
                <div className="col-sm-4 col-12">
                  <div id="date_range_wrapper">
                    <RangePicker onChange={this.onDateRangeChange} />
                  </div>
                </div>
                <div className="col-sm-2 col-2 padding-0 pull-xs-left">
                  <button className="btn submit-btn xs-hide" type="button" onClick={() => this.setChoiceWorkOrder(true)}>Create Work Order</button>
                  <button className="btn submit-btn xs-show" type="button" onClick={() => this.setChoiceWorkOrder(true)}><i
                    className="fa fa-plus" /></button>
                </div>
                <div className="col-sm-3 col-10 pull-xs-right">
                  <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })}
                    style={{ width: "100%" }} />
                </div>
                <div className="col-sm-3 col-12 edit-div">
                  <span>{pagination.total} Records</span>

                  <button className="btn btn-edit" title="Trash" onClick={this.onMultipleRowDeleteClick}>
                    <i className="fa fa-trash-o" />
                  </button>
                  <button type="primary" onClick={this.onMultipleRowShowClick} className="btn btn-edit">
                    <i className="fa fa-eye" />
                  </button>
                </div>
              </div>
              <div className="row clearfix">
                <div className="col-12">
                  <div className="listing-table">
                    <Table
                      className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                      pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                      dataSource={data} loading={loading} onChange={this.handleTableChange}
                      locale={{ emptyText: 'No Work Order Available' }} />
                  </div>
                </div>
                <div className="col-12">
                  <h4 className="timeline-heaing">Job History</h4>
                  <Timeline mode="alternate">
                    <Timeline.Item color="green" dot={<i className="fa fa-check" style={{ fontSize: '16px' }} />}>
                      <ul>
                        <li><i className="fa fa-file-text"> </i> Note Created</li>
                        <li><i className="fa fa-clock-o"> </i> 07/03/18 12:05 PM</li>
                        <li><i className="fa fa-user-circle-o"> </i> Shannon Franz</li>
                      </ul>
                      <p>uploaded and chart to Deb R for billing</p>
                      <a href="#"><i className="fa fa-trash"> </i> </a>
                      <a href="#"><i className="fa fa-eye"> </i> </a>
                    </Timeline.Item>
                    <Timeline.Item color="green" dot={<i className="fa fa-check" style={{ fontSize: '16px' }} />}>
                      <ul>
                        <li><i className="fa fa-dollar"> </i> Pricing Created</li>
                        <li><i className="fa fa-clock-o"> </i> 07/03/18 12:05 PM</li>
                        <li><i className="fa fa-user-circle-o"> </i> John Brown</li>
                      </ul>
                      <p>uploaded and chart to Deb R for billing</p>
                      <a href="#"><i className="fa fa-trash"> </i> </a>
                      <a href="#"><i className="fa fa-eye"> </i> </a>
                    </Timeline.Item>
                    {/*<Timeline.Item color="green" dot={<i className="fa fa-check" style={{ fontSize: '16px' }} />}>*/}
                      {/*<ul>*/}
                        {/*<li><i className="fa fa-file-text"> </i> Note Created</li>*/}
                        {/*<li><i className="fa fa-clock-o"> </i> 07/03/18 12:05 PM</li>*/}
                        {/*<li><i className="fa fa-user-circle-o"> </i> Dan Kulger</li>*/}
                      {/*</ul>*/}
                      {/*<div className="timeline-amt">*/}
                        {/*<p><strong>Non Taxable:</strong>$0.0 </p>*/}
                        {/*<p><strong>Taxable:</strong>$930.0 </p>*/}
                        {/*<p><strong>Subtotal:</strong>$930.0 </p>*/}
                        {/*<p><strong>Tax:</strong>$61.59 </p>*/}
                        {/*<p><strong>Total:</strong>$991.0 </p>*/}
                        {/*<p><strong>Category:</strong> Final Estimate</p>*/}
                        {/*<p><strong>Description:</strong> N/A</p>*/}
                        {/*<p><strong>Job Status (At time of Pricing):</strong> Active </p>*/}
                      {/*</div>*/}
                      {/*<a href="#"><i className="fa fa-trash"> </i> </a>*/}
                      {/*<a href="#"><i className="fa fa-eye"> </i> </a>*/}
                    {/*</Timeline.Item>*/}
                    <Timeline.Item color="green" dot={<i className="fa fa-check" style={{ fontSize: '16px' }} />}>
                      <ul>
                        <li><i className="fa fa-file-text"> </i> Note Created</li>
                        <li><i className="fa fa-clock-o"> </i> 07/03/18 12:05 PM</li>
                        <li><i className="fa fa-user-circle-o"> </i> Shannon Franz</li>
                      </ul>
                      <p>Uploaded to SPC</p>
                      <a href="#"><i className="fa fa-trash"> </i> </a>
                      <a href="#"><i className="fa fa-eye"> </i> </a>
                    </Timeline.Item>
                    <Timeline.Item color="green" dot={<i className="fa fa-check" style={{ fontSize: '16px' }} />}>
                      <ul>
                        <li><i className="fa fa-file-text"> </i> Note Created</li>
                        <li><i className="fa fa-clock-o"> </i> 07/03/18 12:05 PM</li>
                        <li><i className="fa fa-user-circle-o"> </i> Doe</li>
                      </ul>
                      <p>Lorem Ipsum</p>
                      <a href="#"><i className="fa fa-trash"> </i> </a>
                      <a href="#"><i className="fa fa-eye"> </i> </a>
                    </Timeline.Item>

                   </Timeline>
                </div>
              </div>
              <Drawer title="Add Work Order" placement="right" onClose={this.onCloseWork} visible={this.state.visibleWorkDrawer}
              className="floating-form" destroyOnClose={true} width={"35%"}>
              <Form>
                <FormItem label="Email">
                  <Input placeholder="Enter  email" />
                </FormItem>
                <FormItem label="City">
                  <Input placeholder="Enter city" />
                </FormItem>
                <FormItem label="State">
                  <Input placeholder="Enter state" />
                </FormItem>
                <FormItem label="Zip Code">
                  <Input placeholder="Enter zip code" />
                </FormItem>
                <FormItem label="Phone">
                  <Input placeholder="Enter phone" />
                </FormItem>
                <FormItem label="Contact">
                  <Input placeholder="Enter contact" />
                </FormItem>
                <Button type="primary" htmlType="button" >
                  Add Work Order
                </Button>
              </Form>
            </Drawer>
              <AddUpdateTaskForm visible={this.state.visibleDetails} onClose={()=>this.showDetailsDrawer(false)} />
              <div className="modal">
                <AddUpdateWorkOrder moderated={this.state.moderatedWorkOrder} visible={this.state.addUpdateWorkOrderModel} setModelVisible={() => this.setAddUpdateWorkOrderModel(false)} fetch={() => this.fetch()} />
              </div>
              <ShowWorkOrder visible={this.state.showWorkOrderModel} setModelVisible={() => this.setShowWorkOrderModel(false)} data={this.state.showWorkOrderModelData} />
              <ChoiceWorkOrderCreate visible={this.state.setChoiceWorkOrderModel} importQuote={() => this.openImportQuoteModel(true)} addNewWorkOrder={() => this.openAddNewWorkOrder(true)} setModelVisible={() => this.setChoiceWorkOrder(false)} />
              <ImportQuote visible={this.state.selectQuoteVisible} fetch={() => this.fetch()} setModelVisible={() => this.setSelectQuoteVisible(false)} />
              <Modal title="Select Print Option" confirmLoading={printBtnLoading} visible={this.state.printVisible} onOk={this.onWorkorderRowPrintClick} onCancel={this.handleCancel} okText="Download PDF" className="print-modal" width={300} destroyOnClose={true}>
                <div>
                  <div className="check-div">
                    <Checkbox name={WORKORDER} value={row_id} onChange={this.selectedChoicesPrint}>Print Work Order</Checkbox>
                  </div>
                  {data.map(row => {
                    return (row.id === row_id ? (
                      row.service.map((service, index) => {
                        return (<div key={index} className="check-div capitalize-letter">
                          <Checkbox value={service.manifest_number} name={MANIFEST+index} onChange={this.selectedChoicesPrint}>Print {service.type}: {service.manifest_number}</Checkbox>
                        </div>)
                      })
                    ) : '')
                  })}
                </div>
              </Modal>
            </div>
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/crm/project_log/ProjectLog.jsx